var map = {
	"./handbook-thumb-coral-reef.png": 1019,
	"./handbook-thumb-earth.png": 1020,
	"./handbook-thumb-homes.png": 1021,
	"./handbook-thumb-human-body.png": 1022,
	"./handbook-thumb-mammals.png": 1023,
	"./handbook-thumb-simple-machines.png": 1024,
	"./handbook-thumb-skyscrapers.png": 1025,
	"./handbook-thumb-space.png": 1026,
	"./handbook-thumb-states-of-matter.png": 1027,
	"./handbook-thumb-weather.png": 1028
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1018;